import { Reservation_List_Reservation_Status } from "@/lib/gql/__generated__/graphql";

const activeReservationStatuses = new Set<Reservation_List_Reservation_Status>([
	Reservation_List_Reservation_Status.NewRequest,
	Reservation_List_Reservation_Status.Reserved,
	Reservation_List_Reservation_Status.OnsitePaymentForPaymentError,
]);

export const isActiveReservationStatus = (reservationStatus: Reservation_List_Reservation_Status): boolean =>
	activeReservationStatuses.has(reservationStatus);
